import { matchPath, useLocation, useMatch } from 'react-router-dom';

import { RouteKey } from './navigationUtils';
import { computedRoutes } from './routes';

export function useRouteKeyMatch(key: RouteKey): boolean {
  return !!useMatch(computedRoutes[key]);
}

export function useMatchingRouteKey<T extends RouteKey>(keys: T[]): T | null {
  const { pathname } = useLocation();
  return keys.find((key) => matchPath(computedRoutes[key], pathname)) ?? null;
}
